$(document).on 'turbolinks:load', ->
  $('#update-without-fvs').off().on 'click', ->
    $('#input-without-fvs').val('true')
    form_element = document.querySelector('#servico_form')
    Rails.fire(form_element, 'submit')
